export const errors = {
  emailAddressAlreadyInUse: {
    code: 'auth/email-already-in-use',
  },
  recaptchaFailed: {
    message: 'Recaptcha Failed',
    code: '000001-recaptcha-failed',
  },
};
